export const Roles = {
    Staff: 'staff',
    MusicManager: 'musicManager',
    GeneralManager: 'generalManager',
    Admin: 'admin',
};

